import { render, staticRenderFns } from "./RptOrdenesNegativas.vue?vue&type=template&id=e56ed49a&"
import script from "./RptOrdenesNegativas.vue?vue&type=script&lang=js&"
export * from "./RptOrdenesNegativas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports